export type BookingPrivacyState = "active" | "terminal" | "deleted";

export interface BookingPrivacy {
  state: BookingPrivacyState;
  canDelete: boolean;
  deletedAt: string | null;
  deletionScope: "booking_and_consultation";
}

export type BookingPrivacyBusy = "export" | "delete" | null;

export function bookingPrivacyControls(
  privacy: BookingPrivacy,
  busy: BookingPrivacyBusy,
  confirmationOpen: boolean,
) {
  const terminal = privacy.state === "terminal" && privacy.canDelete;
  return {
    description:
      privacy.state === "deleted"
        ? "남아 있는 예약 운영 기록을 내려받을 수 있어요."
        : "이 예약에 입력한 내용을 내려받을 수 있어요. 연락처를 고치려면 고객지원에서 본인 확인 후 도와드려요.",
    exportLabel: busy === "export" ? "내려받는 중…" : "내 예약 정보 내려받기",
    deleteLabel: busy === "delete" ? "지우는 중…" : "정보 지우기",
    controlsDisabled: busy !== null,
    showDeleteEntry: terminal && !confirmationOpen,
    showConfirmation: terminal && confirmationOpen,
    showDeletedReceipt: privacy.state === "deleted",
    activeHelp:
      privacy.state === "active"
        ? "예약이 끝나거나 취소된 뒤 연락처와 요청 내용을 지울 수 있어요."
        : null,
  };
}
